import { Tooltip } from 'antd'
import CopyIcon from 'components/icons/CopyIcon'
import DeleteIcon from 'components/icons/DeleteIcon'
import EditIcon from 'components/icons/EditPenIcon.js'
import moment from 'moment'
import React, { useEffect } from 'react'
import { formatDateWithOrdinal } from '../../..'
import { Icon, IconsWrapper } from '../partials/Upcoming/style'
import {
  CompletedText,
  EventAnswer,
  EventAnswer1,
  EventCategory,
  EventDay,
  EventHeading,
  EventStatusCard,
  EventText,
  EventTitle,
  EventTitleSection,
  VerticalLine,
} from '../style'

export default function EventCard({
  variant,
  eventName,
  occurrence,
  allDayEvent,
  isRegister,
  location,
  categoryBasedObj,
  isApplied,
  handleClick,
  selectedData,
  endTime,
  startTime,
  handleDeleteEvent,
  handleCopyEvent,
  handleEditEvent,
  state,
}) {
  let checkLength = allDayEvent ? 12 : 22
  const hasStartAndEndTime = startTime && endTime
  const style = hasStartAndEndTime ? { marginLeft: '-10px' } : {}
  const formatTime = time => {
    let timeSplit

    if (moment.isMoment(time)) {
      timeSplit = time.format('HH:mm')
    } else if (typeof time === 'string' && time?.includes(':')) {
      timeSplit = time
    } else {
      console.error('Invalid time format')
      return ''
    }

    const [hour, minute] = timeSplit?.split(':') || []
    const hourNumber = parseInt(hour, 10)
    const period = hourNumber >= 12 ? 'PM' : 'AM'
    const formattedHour = hourNumber % 12 || 12
    return `${formattedHour}:${minute} ${period}`
  }
  useEffect(() => {
    //console.log(new Date())
  }, [])

  return (
    <EventStatusCard
      styleBasedObj={categoryBasedObj}
      variant={variant}
      width="99%"
      mBottom={'8px'}
    >
      <EventText>
        <EventDay allDayEvent={allDayEvent} style={style}>
          {allDayEvent
            ? 'All day'
            : startTime && endTime
            ? `${formatTime(startTime)} - ${formatTime(endTime)}`
            : '-'}
        </EventDay>
        <VerticalLine show={true} styleBasedObj={categoryBasedObj} />
      </EventText>
      <EventTitleSection customWidth={'320px'}>
        <div
          style={{
            display: allDayEvent ? 'flex' : 'block',
            alignItems: 'center',
            gap: eventName?.length > 12 ? '0px' : '4px',
          }}
        >
          <Tooltip title={eventName}>
            <EventTitle
              ellipse={eventName?.length > 12}
              isWidth={checkLength > 20}
            >
              {eventName?.toLowerCase() ?? ''}
            </EventTitle>
          </Tooltip>
          <EventCategory>
            {categoryBasedObj?.status
              ? '(' + categoryBasedObj?.status + ')'
              : '-'}
          </EventCategory>
        </div>
        <VerticalLine show={true} styleBasedObj={categoryBasedObj} />
      </EventTitleSection>
      <EventTitleSection customWidth={'220px'}>
        {occurrence && isApplied ? (
          <CompletedText>Registration completed!</CompletedText>
        ) : (
          <div>
            {/* <EventHeading>
                {isRegister ? 'Registration end date' : 'Event Dates'}
              </EventHeading>
              <EventAnswer>
                {isRegister
                  ? formatDateWithOrdinal(
                      new Date(selectedData?.registerEndDate)
                    )
                  : formatDateWithOrdinal(
                      new Date(selectedData?.startDate),
                      'month'
                    ) +
                    '-' +
                    formatDateWithOrdinal(
                      new Date(selectedData?.endDate),
                      'month'
                    
                    )}
                    
              </EventAnswer> */}
            <EventHeading>
              {isRegister
                ? selectedData?.registerEndDate &&
                  new Date()?.toISOString()?.split('T')[0] >
                    new Date(selectedData?.registerEndDate)
                      ?.toISOString()
                      ?.split('T')[0]
                  ? 'Event Dates' // If today is past registerEndDate (date only), show Event Dates
                  : 'Registration end date'
                : 'Event Dates'}
            </EventHeading>
            <EventAnswer>
              {isRegister
                ? selectedData?.registerEndDate &&
                  new Date()?.toISOString()?.split('T')[0] >
                    new Date(selectedData?.registerEndDate)
                      ?.toISOString()
                      ?.split('T')[0]
                  ? selectedData?.startDate1
                    ? selectedData?.startDate1.split('T')[0] ===
                      selectedData?.endDate1.split('T')[0]
                      ? formatDateWithOrdinal(
                          new Date(selectedData?.startDate1)
                        )
                      : `${formatDateWithOrdinal(
                          new Date(selectedData?.startDate1),
                          'month'
                        )}-${formatDateWithOrdinal(
                          new Date(selectedData?.endDate1),
                          'month'
                        )}`
                    : '-'
                  : selectedData?.registerEndDate
                  ? formatDateWithOrdinal(
                      new Date(selectedData?.registerEndDate)
                    )
                  : '-'
                : selectedData?.startDate1
                ? selectedData?.startDate1.split('T')[0] ===
                  selectedData?.endDate1.split('T')[0]
                  ? formatDateWithOrdinal(new Date(selectedData?.startDate1))
                  : `${formatDateWithOrdinal(
                      new Date(selectedData?.startDate1),
                      'month'
                    )}-${formatDateWithOrdinal(
                      new Date(selectedData?.endDate1),
                      'month'
                    )}`
                : '-'}
            </EventAnswer>
          </div>
        )}
        <VerticalLine show={!!location} styleBasedObj={categoryBasedObj} />
      </EventTitleSection>
      {location ? (
        <EventTitleSection customWidth={'250px'}>
          <div>
            <EventHeading>{'Event Location'}</EventHeading>
            <Tooltip title={location}>
              <EventAnswer1>{location?.toLowerCase()}</EventAnswer1>
            </Tooltip>
          </div>
          <VerticalLine show={false} styleBasedObj={categoryBasedObj} />
        </EventTitleSection>
      ) : null}

      <IconsWrapper>
        <Icon onClick={handleDeleteEvent}>
          <DeleteIcon />
        </Icon>
        <Icon onClick={handleEditEvent}>
          <EditIcon />
        </Icon>
        {state?.eventStatus != 'DRAFT' && (
          <Icon onClick={handleCopyEvent}>
            <CopyIcon />
          </Icon>
        )}
      </IconsWrapper>
    </EventStatusCard>
  )
}
